import React from "react";
import ReactDOM from "react-dom/client";


import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import i18next from "i18next";
import { TourProvider } from '@reactour/tour'
import { I18nextProvider, initReactI18next } from "react-i18next";
import english from "./translations/en/global.json";
import frensh from "./translations/fr/global.json";


export const steps = [

  {
    selector: '#first-step',
    content: "Bienvenue sur la démo d'evaluation de ISOVAL ",
  },
  {
    selector: '#abonnement',
    content: "En fonction de votre plan d'abonnement choisi ,  plusieurs niveaux vous seront proposés  ",
  },
  {
    selector: '#choix',
    content: "Vous avez le choix parmis ces trois niveaux mais pour cette démo vous allez être redirigé",
  },
 
  {
    selector: '#niveau2',
    content: "Veuillez cliquer ici sur le thème : 'Commencer l’évaluation SSI' pour continuer ",
  },
  {
    selector: '#second-step',
    content: "Bienvenue sur la deuxième partie , concernant la partie évaluation de votre niveau , ici vous y trouverez toutes les démarches à suivre ",
  },
  {
    selector: '#recapitulatif', 
    content: "Rappel de votre niveau  actuel",
  },
  {
    selector: '#avancement',
    content: "Vous pouvez voir votre taux d'avancement global",
  },
  
  {
    selector: '#section_en_cours',
    content: "Le chapitre/la section en cours ",
  },
  
  {
    selector: '#total_question',
    content: "Le nombre total  de questions à répondre",
  },
  {
    selector: '#temps_restant',
    content: "Un minuteur pour compter le temps",
  },
  {
    selector: '#questions',
    content: " Ici vous avez l'ensemble des questions à répondre , vous avez les choix multiples et/ou aussi le chargement d'un fichier si nécessaire.",
  },
  {
    selector: '#previous',
    content: "Pour retourner à la question précedente ",
  },
  {
    selector: '#next',
    content: "Ou passer à la question suivante ",
  },
  {
    selector: '#save',
    content: "Vous pourriez sauvegarder les réponses pour y revenir plutard",
  },
  {
    selector: '#soumettre',
    content: "Envoyez vos réponses si vous avez terminé l'évaluation",
  },
  {
    selector: '#resultat',
    content: "Cliquez ici pour voir votre résultat",
  },
  {
    selector: '#hs-ai-modal',
    content: "Votre score final que vous pourrez imprimer",
  },

  
  

]
var localData = localStorage.getItem("lang");
console.log("=================", localData);
var currentLang = "fr";
if (localData != null) {
  currentLang = JSON.parse(localData);
}
document.documentElement.lang = currentLang;
i18next.use(initReactI18next).init({
  resources: {
    en: {
      global: english,
    },
    fr: {
      global: frensh,
    },
  },
  lng: currentLang,
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
      {/*<TourProvider >*/}
    <I18nextProvider i18n={i18next}>
      <RouterProvider router={router} />
    </I18nextProvider>
    {/*</TourProvider>*/}
  </React.StrictMode>
);
